module.exports = __webpack_public_path__ + "static/img/zxgy-img.0a316713.png";